import { render, staticRenderFns } from "./CarInfractionsModal.vue?vue&type=template&id=3070ff75&scoped=true&"
import script from "./CarInfractionsModal.vue?vue&type=script&lang=ts&"
export * from "./CarInfractionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./car-infractions-modal.scss?vue&type=style&index=0&id=3070ff75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070ff75",
  null
  
)

export default component.exports